// in percents
export const REFILL_REGULAR_BONUS = 50;
